export const ROUTE_PATHS = {
  HOME: '/',
  REQUIREMENTS: '/requirements',
  SYSTEM_DESIGN: '/system-design',
  SCHEDULE: '/schedule',
} as const;

export interface ProjectPlan {
  id: string;
  title: string;
  description: string;
  department: string;
  year: number;
  semester: number;
  startDate: string;
  endDate: string;
  totalWeeks: number;
}

export interface TeamInfo {
  id: string;
  name: string;
  grade: number;
  members: StudentInfo[];
  projectType: 'ai' | 'hanium';
  mentor?: string;
}

export interface StudentInfo {
  id: string;
  studentNumber: string;
  name: string;
  photo?: string;
  teamId: string;
}

export interface WeeklyProgress {
  id: string;
  teamId: string;
  week: number;
  date: string;
  status: 'completed' | 'in-progress' | 'pending';
  description: string;
  submittedBy?: string;
  submittedAt?: string;
}

export interface ScoreItem {
  id: string;
  studentId: string;
  category: 'attendance' | 'assignment' | 'presentation' | 'participation' | 'team-contribution';
  score: number;
  maxScore: number;
  week?: number;
  date: string;
  notes?: string;
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};

export const calculateProgress = (completed: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round((completed / total) * 100);
};
